<template>
  <div class="report">
    <ContentHeader :show-back="false" />
    <div class="content-container" v-loading="loading">
      <!-- reportList循环对象 -->
      <!-- <div>
        <div
          class="query-panel"
          v-for="(item, index) in reportList"
          :key="index"
          v-show="getShow(item)"
        >
          <div class="title">
            {{ item.title }}导出文件
            <span v-if="item.typeFlag">（ {{ item.typeFlag }}版 ）</span>
          </div>
          <el-form
            ref="stockForm"
            :model="item"
            label-position="right"
            label-width="150px"
            size="small"
            class="query-form"
          >
            <el-row> -->
              <!-- 非低级用户则显示bu -->
              <!-- <el-col :span="11" v-if="levelFlag !== 'basic'">
                <el-form-item label="请选择BU">
                  <el-select
                    :popper-append-to-body="false"
                    v-model="item.param.buCodes"
                    placeholder="请选择BU"
                    clearable
                    multiple
                    filterable
                    @change="getRegion(item)"
                  >
                    <el-option
                      v-for="option in buList"
                      :key="option.orgCode"
                      :label="`${option.orgCode}-${option.orgName}`"
                      :value="option.orgCode"
                    />
                  </el-select>
                </el-form-item>
              </el-col> -->
              <!-- 低级用户||按region选择  显示region -->
              <!-- <el-col
                :span="11"
                v-if="levelFlag === 'basic' || item.typeFlag === 'region'"
              >
                <el-form-item label="请选择Region">
                  <el-select
                    :popper-append-to-body="false"
                    v-model="item.param.regionCodes"
                    placeholder="请选择Region"
                    clearable
                    filterable
                    multiple
                  >
                    <el-option
                      v-for="option in item.regionList"
                      :key="option.orgCode"
                      :label="`${option.orgCode}-${option.orgName}`"
                      :value="option.orgCode"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11" v-if="item.showChannel">
                <el-form-item label="请选择渠道">
                  <el-select
                    :popper-append-to-body="false"
                    v-model="item.param.channelCode"
                    placeholder="请选择渠道"
                    clearable
                  >
                    <el-option
                      v-for="(option, index) in channelList"
                      :key="index"
                      :label="option.channelName"
                      :value="option.channelCode"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="template">
                <el-button
                  class="btn-blue-plain template-btn"
                  @click="handleExport(item)"
                >
                  <i class="iconfont iconzu22" />导出文件
                </el-button>
                <el-button
                  class="btn-grey-plain"
                  @click="resetParam(item)"
                  size="small"
                  >重置</el-button
                >
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div> -->
      <!-- trade明细导出 -->
      <div class="query-panel" v-if="employeeLevel < 90">
        <div class="title">
          Trade+明细导出
        </div>
        <el-form
          ref="tradeForm"
          :model="tradeParam"
          label-position="right"
          label-width="150px"
          size="small"
          class="query-form"
        >
          <el-row>
            <el-col :span="11" v-if="levelFlag !== 'basic'">
              <el-form-item label="请选择BU">
                <el-select
                  :popper-append-to-body="false"
                  v-model="tradeParam.param.buCodes"
                  placeholder="请选择BU"
                  clearable
                  multiple
                  filterable
                  @change="getRegion(tradeParam)"
                >
                  <el-option
                    v-for="option in buList"
                    :key="option.orgCode"
                    :label="`${option.orgCode}-${option.orgName}`"
                    :value="option.orgCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="请选择Region">
                <el-select
                  :popper-append-to-body="false"
                  v-model="tradeParam.param.regionCodes"
                  placeholder="请选择Region"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="option in tradeParam.regionList"
                    :key="option.orgCode"
                    :label="`${option.orgCode}-${option.orgName}`"
                    :value="option.orgCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="is-trade">
            <!-- trade明细导出 基本条件start -->
            <el-row>
              <el-col :span="8">
                <el-form-item label="开始时间">
                  <el-date-picker
                    style="width:200px;"
                    v-model="tradeParam.param.applyDateFrom"
                    type="date"
                    placeholder="请选择开始时间"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="截止时间">
                  <el-date-picker
                    style="width:200px;"
                    v-model="tradeParam.param.applyDateTo"
                    type="date"
                    placeholder="请选择截止时间"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="申请单号">
                  <el-input
                    v-model="tradeParam.param.applyNumber"
                    clearable
                    style="width: 200px;"
                    placeholder="请输入申请单号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="供应商名称">
                  <el-input
                    clearable
                    v-model="tradeParam.param.vendorName"
                    style="width: 200px;"
                    placeholder="请输入供应商名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="售点名称">
                  <el-input
                    clearable
                    v-model="tradeParam.param.pocName"
                    style="width: 200px;"
                    placeholder="请输入售点名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="售点编码">
                  <el-input
                    clearable
                    v-model="tradeParam.param.pocCode"
                    style="width: 200px;"
                    placeholder="请输入售点编码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="主执行类型">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.param.execType"
                    clearable
                    filterable
                    placeholder="主执行类型"
                  >
                    <el-option
                      v-for="item in tradeExecTypeMainMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="项目类型">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.param.execTypeSub"
                    clearable
                    filterable
                    placeholder="选取后展示更多条件"
                  >
                    <el-option
                      v-for="item in showTradeExecTypeSubMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
               <el-col :span="8">
              <el-form-item label="业务月份" >
                <el-date-picker 
                  value-format="yyyy-MM" 
                  style="width:200px;" 
                  v-model="tradeParam.param.budgetMonth" 
                  type="month"
                  placeholder="选择月" 
                  size="mini" 
                  clearable>
                </el-date-picker>
              </el-form-item>
            </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="申请类型">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.param.applyType"
                    clearable
                    filterable
                    placeholder="请选择申请类型"
                  >
                    <el-option
                      v-for="item in tradeApplyTypeMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
            <!-- trade明细导出 基本条件end -->
            <!-- trade明细导出 店招start -->
            <el-row v-if="showTradeSub === 'showShopQuery'">
              <el-col :span="8">
                <el-form-item label="申请单状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.shopQueryParam.applyStatus"
                    clearable
                    filterable
                    placeholder="请选择申请单状态"
                  >
                    <el-option
                      v-for="item in tradeApplyStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-if="tradeParam.param.applyType !== '02'"
                v-model="tradeParam.shopQueryParam.requirementStatus"
              >
                <el-form-item label="需求审批状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.shopQueryParam.requirementStatus"
                    clearable
                    filterable
                    placeholder="请选择需求审批状态"
                  >
                    <el-option
                      v-for="item in pocCustomRequirementStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="方案审批状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.shopQueryParam.solutionStatus"
                    clearable
                    filterable
                    placeholder="请选择方案审批状态"
                  >
                    <el-option
                      v-for="item in tradeSolutionStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="施工状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.shopQueryParam.executionStatus"
                    clearable
                    filterable
                    placeholder="请选择施工状态"
                  >
                    <el-option
                      v-for="item in tradeExecutionStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="验收状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.shopQueryParam.acceptanceStatus"
                    clearable
                    filterable
                    placeholder="请选择验收状态"
                  >
                    <el-option
                      v-for="item in tradeAcceptanceStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- trade明细导出 店招end -->
            <!-- trade明细导出 冰柜start -->
            <el-row v-if="showTradeSub === 'showCoolerQuery'">
              <el-col :span="8">
                <el-form-item label="冰柜申请单状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.coolerQueryParam.applyStatus"
                    clearable
                    filterable
                    placeholder="请选择冰柜申请单状态"
                  >
                    <el-option
                      v-for="item in tradeFreezerApplyStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="冰柜需求审批状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.coolerQueryParam.requirementStatus"
                    clearable
                    filterable
                    placeholder="请选择冰柜需求审批状态"
                  >
                    <el-option
                      v-for="item in pocCustomRequirementStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="冰柜订单状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.coolerQueryParam.solutionStatus"
                    clearable
                    filterable
                    placeholder="请选择冰柜订单状态"
                  >
                    <el-option
                      v-for="item in tradeFreezerSolutionStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="冰柜发货状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.coolerQueryParam.executionStatus"
                    clearable
                    filterable
                    placeholder="请选择冰柜发货状态"
                  >
                    <el-option
                      v-for="item in tradeFreezerExecutionStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="冰柜验收状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.coolerQueryParam.acceptanceStatus"
                    clearable
                    filterable
                    placeholder="请选择冰柜验收状态"
                  >
                    <el-option
                      v-for="item in tradFreezerAcceptanceStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- trade明细导出 冰柜end -->
            <!-- trade明细导出 堆箱start -->
            <el-row v-if="showTradeSub === 'showStockQuery'">
              <el-col :span="8">
                <el-form-item label="堆箱申请单状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.stockQueryParam.applyStatus"
                    clearable
                    filterable
                    placeholder="请选择堆箱申请单状态"
                  >
                    <el-option
                      v-for="item in tradeStackApplyStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="堆箱审批状态">
                  <el-select
                    style="width: 200px;"
                    v-model="tradeParam.stockQueryParam.requirementStatus"
                    clearable
                    filterable
                    placeholder="请选择堆箱审批状态"
                  >
                    <el-option
                      v-for="item in tradeStackRequirementStatusMap"
                      :label="item.value"
                      :value="item.key"
                      :key="item.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- trade明细导出 堆箱end -->
            <el-row>
              <el-col class="template">
                <el-button
                  class="btn-blue-plain template-btn"
                  @click="handleExport(tradeParam)"
                >
                  <i class="iconfont iconzu22" />导出文件
                </el-button>
                <el-button
                  class="btn-grey-plain"
                  @click="resetParam(tradeParam)"
                  size="small"
                  >重置</el-button
                >
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <!-- 采购订单明细导出 -->
      <div class="query-panel">
        <div class="title">采购订单明细导出</div>
        <el-form
          ref="purchaseForm"
          :model="purchaseParam"
          label-position="right"
          label-width="150px"
          size="small"
          class="query-form"
        >
          <el-row>
            <el-col :span="11" v-if="levelFlag !== 'basic'">
              <el-form-item label="请选择BU">
                <el-select
                  :popper-append-to-body="false"
                  v-model="purchaseParam.param.buCodes"
                  placeholder="请选择BU"
                  clearable
                  multiple
                  filterable
                  @change="getRegion(purchaseParam)"
                >
                  <el-option
                    v-for="option in buList"
                    :key="option.orgCode"
                    :label="`${option.orgCode}-${option.orgName}`"
                    :value="option.orgCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="请选择Region">
                <el-select
                  :popper-append-to-body="false"
                  v-model="purchaseParam.param.regionCodes"
                  placeholder="请选择Region"
                  clearable
                  multiple
                  filterable
                >
                  <el-option
                    v-for="option in purchaseParam.regionList"
                    :key="option.orgCode"
                    :label="`${option.orgCode}-${option.orgName}`"
                    :value="option.orgCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="开始时间">
                <el-date-picker
                  style="width:200px;"
                  v-model="purchaseParam.param.orderDateFrom"
                  type="date"
                  placeholder="请选择开始时间"
                  value-format="yyyy-MM-dd"
                  class="form-date-item"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="截止时间">
                <el-date-picker
                  style="width:200px;"
                  v-model="purchaseParam.param.orderDateTo"
                  type="date"
                  placeholder="请选择截止时间"
                  value-format="yyyy-MM-dd"
                  class="form-date-item"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单编号">
                <el-input
                  v-model="purchaseParam.param.orderNumber"
                  clearable
                  style="width: 200px;"
                  placeholder="请输入订单编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="PO编号">
                <el-input
                  v-model="purchaseParam.param.poNumber"
                  clearable
                  style="width: 200px;"
                  placeholder="请输入PO编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品名称">
                <el-input
                  v-model="purchaseParam.param.itemName"
                  clearable
                  style="width: 200px;"
                  placeholder="请输入商品名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品编号">
                <el-input
                  v-model="purchaseParam.param.itemCode"
                  clearable
                  style="width: 200px;"
                  placeholder="请输入商品编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单类型">
                <el-select
                  style="width: 200px;"
                  v-model="purchaseParam.param.orderType"
                  clearable
                  filterable
                  placeholder="请选择订单类型"
                >
                  <el-option
                    v-for="item in showOrderTypeList"
                    :label="item.value"
                    :value="item.key"
                    :key="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否冰柜">
                <el-select
                  style="width: 200px;"
                  v-model="purchaseParam.param.isIcebox"
                  clearable
                  filterable
                  placeholder="请选择是否冰柜"
                >
                  <el-option label="是" value="1" />
                  <el-option label="否" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否加急">
                <el-select
                  style="width: 200px;"
                  v-model="purchaseParam.param.isUrgent"
                  clearable
                  filterable
                  placeholder="请选择是否加急"
                >
                  <el-option label="是" value="1" />
                  <el-option label="否" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单状态">
                <el-select
                  style="width: 200px;"
                  v-model="purchaseParam.param.orderStatus"
                  clearable
                  filterable
                  placeholder="请选择订单状态"
                >
                  <el-option
                    v-for="item in orderStatusList"
                    :label="item.value"
                    :value="item.key"
                    :key="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="生产状态">
                <el-select
                  style="width: 200px;"
                  v-model="purchaseParam.param.detailStatus"
                  clearable
                  filterable
                  placeholder="请选择生产状态"
                >
                  <el-option
                    v-for="item in orderDetailStatusList"
                    :label="item.value"
                    :value="item.key"
                    :key="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="业务月份" >
                <el-date-picker 
                  value-format="yyyy-MM" 
                  style="width:200px;" 
                  v-model="purchaseParam.param.budgetMonth" 
                  type="month"
                  placeholder="选择月" 
                  size="mini" 
                  clearable>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="PR编号" >
                <el-input
                  v-model="purchaseParam.param.prNumber"
                  clearable
                  style="width: 200px;"
                  placeholder="请输入PR编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="打样状态">
                <el-select
                  style="width: 200px;"
                  v-model="purchaseParam.param.proofStatus"
                  clearable
                  filterable
                  placeholder="请选择打样状态"
                >
                  <el-option
                    v-for="item in proofStatusList"
                    :label="item.value"
                    :value="item.key"
                    :key="item.key"
                  />
                </el-select> </el-form-item
            ></el-col> -->
          </el-row>
          <el-row>
            <el-col class="template">
              <el-button
                class="btn-blue-plain template-btn"
                @click="handleExport(purchaseParam)"
              >
                <i class="iconfont iconzu22" />导出文件
              </el-button>
              <el-button
                class="btn-grey-plain"
                @click="resetParam(purchaseParam)"
                size="small"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <v-form ref="form" :url="exportUrl" :params="exportParam" />
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import { commonUtils } from '@/utils/common'
import { mapState, mapGetters } from 'vuex'
import vForm from '@/components/v-form'
import baseApi from '@/api/base'
export default {
  name: 'report',
  components: {
    ContentHeader,
    vForm
  },
  data () {
    return {
      loading: false,
      exportParam: {},
      exportUrl: null,
      // pickerOptionsStart: {},
      // pickerOptionsEnd: {},
      buList: [],
      levelFlag: '',
      employeeLevel: '',
      channelList: [],
      reportList: [
        // typeFlag:'bu' 表示可依据bu进行筛选（会出现bu筛选框，不显示region筛选框）
        // typeFlag:'region' 表示可依据region进行筛选（高级是bu-region联动，低级则直接获取并显示region）
        {
          id: 'qdxm-bu',
          title: '渠道项目进度一览表',
          api: '/report/channel-schedule/export/by-bu',
          typeFlag: 'bu',
          regionList: [],
          param: {
            buCodes: ''
          }
        },
        {
          id: 'qdxm-re',
          title: '渠道项目进度一览表',
          api: '/report/channel-schedule/export/by-region',
          typeFlag: 'region',
          regionList: [],
          param: {
            buCodes: '',
            regionCodes: ''
          }
        },
        {
          id: 'gddz-bu',
          title: '门店定制渠道项目详表',
          api: '/report/high-channel/bu',
          regionList: [],
          typeFlag: 'bu',
          showChannel: true,
          param: {
            buCodes: '',
            channelCode: ''
          }
        },
        {
          id: 'gddz-re',
          title: '门店定制渠道项目详表',
          api: '/report/high-channel/region',
          regionList: [],
          typeFlag: 'region',
          showChannel: true,
          param: {
            buCodes: '',
            regionCodes: '',
            channelCode: ''
          }
        },
        {
          id: 'spt-bu',
          title: '双平台预算管理一览表',
          api: '/report/doubleplat-budget/bu',
          regionList: [],
          typeFlag: 'bu',
          param: {
            buCodes: ''
          }
        },
        {
          id: 'spt-re',
          title: '双平台预算管理一览表',
          api: '/report/doubleplat-budget/region',
          regionList: [],
          typeFlag: 'region',
          param: {
            buCodes: '',
            regionCodes: ''
          }
        }
      ],
      // 非reportList里的导出，需要在getBuRegion函数内配置低级时的regionList
      // trade明细导出
      tradeParam: {
        api: '/trade-apply/export/detail/export',
        regionList: [],
        isTrade: true,
        param: {
          buCodes: '',
          regionCodes: '',
          applyType: '',
          applyNumber: '',
          vendorName: '',
          pocName: '',
          pocCode: '',
          execType: '',
          execTypeSub: '',
          applyDateFrom: '',
          applyDateTo: '',
          budgetMonth: ''
        },
        shopQueryParam: {
          applyStatus: '',
          requirementStatus: '',
          solutionStatus: '',
          executionStatus: '',
          acceptanceStatus: ''
        },
        coolerQueryParam: {
          applyStatus: '',
          solutionStatus: '',
          requirementStatus: '',
          executionStatus: '',
          acceptanceStatus: ''
        },
        stockQueryParam: {
          applyStatus: '',
          requirementStatus: ''
        }
      },
      // 采购订单明细导出
      purchaseParam: {
        api: '/purchase/export',
        regionList: [],
        isPurchase: true,
        param: {
          buCodes: '',
          regionCodes: '',
          orderNumber: '',
          poNumber: '',
          itemName: '',
          itemCode: '',
          orderType: '',
          isIcebox: '',
          isUrgent: '',
          orderStatus: '',
          detailStatus: '',
          proofStatus: '',
          orderDateFrom: '',
          orderDateTo: '',
          budgetMonth: '',
          prNumber:''
        }
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      tradeApplyTypeMap: state => state.base.tradeApplyTypeMap,
      tradeApplyStatusMap: state => state.base.tradeApplyStatusMap,
      tradeExecTypeMainMap: state => state.base.tradeExecTypeMainMap,
      tradeExecTypeSubMap: state => state.base.tradeExecTypeSubMap,
      pocCustomRequirementStatusMap: state => state.base.pocCustomRequirementStatusMap,
      tradeSolutionStatusMap: state => state.base.tradeSolutionStatusMap,
      tradeExecutionStatusMap: state => state.base.tradeExecutionStatusMap,
      tradeAcceptanceStatusMap: state => state.base.tradeAcceptanceStatusMap,
      tradeFreezerApplyStatusMap: state =>
        state.base.tradeFreezerApplyStatusMap,
      tradeFreezerSolutionStatusMap: state =>
        state.base.tradeFreezerSolutionStatusMap,
      tradeFreezerExecutionStatusMap: state =>
        state.base.tradeFreezerExecutionStatusMap,
      tradFreezerAcceptanceStatusMap: state =>
        state.base.tradFreezerAcceptanceStatusMap,
      tradeStackApplyStatusMap: state => state.base.tradeStackApplyStatusMap,
      tradeStackRequirementStatusMap: state =>
        state.base.tradeStackRequirementStatusMap,
      orderTypeList: state => state.base.purchaseOrderTypeMap,
      orderStatusList: state => state.base.purchaseOrderStatusMap,
      orderDetailStatusList: state => state.base.purchaseOrderDetailStatusMap,
      proofStatusList: state => state.base.purchaseOrderProofStatusMap
    }),

    // 过滤采购订单导出 订单类型 下拉内容
    showOrderTypeList () {
      let list = []
      if (this.orderTypeList) {
        list = this.orderTypeList.filter((item) => {
          if(item.key === '01'){
            item.key  = '01,02'
          }
          return item.key !== '02'
        })
      }
      return list
    },

    // 过滤trade明细导出导出 子执行类型 下拉内容
    showTradeExecTypeSubMap () {
      let list = []
      if (this.tradeExecTypeSubMap) {
        list = this.tradeExecTypeSubMap
        list.forEach((item, index) => {
          if (['103','106','107','108','109','301','305'].includes(item.key) ) {
            list.splice(index, 1)
          }
        })
      }
      return list
    },

    // trade明细导出子执行类型
    showTradeSub () {
      let showType = ''
      if (
        this.tradeParam.param.execTypeSub === '101' ||
        this.tradeParam.param.execTypeSub === '201' ||
        this.tradeParam.param.applyType === '02'
      ) {
        showType = 'showShopQuery'
      }
      if (this.tradeParam.param.execTypeSub === '102') {
        showType = 'showCoolerQuery'
      }
      if (this.tradeParam.param.execTypeSub === '103') {
        showType = 'showStockQuery'
      }
      return showType
    }
  },

  created () {
    this.employeeLevel = this.userInfo.employeeLevel
    this.init()
  },
  methods: {
    init () {
      this.getBuRegion()
      this.getChannel()
      // this.$store.dispatch('getDictByName', 'tradeApplyTypeMap')
      this.$store.dispatch('getDictByName', 'tradeApplyStatusMap')
      // this.$store.dispatch('getDictByName', 'tradeExecTypeMainMap')
      this.$store.dispatch('getDictByName', 'tradeExecTypeSubMap')
      this.$store.dispatch('getDictByName', 'pocCustomRequirementStatusMap')
      this.$store.dispatch('getDictByName', 'tradeSolutionStatusMap')
      this.$store.dispatch('getDictByName', 'tradeExecutionStatusMap')
      this.$store.dispatch('getDictByName', 'tradeAcceptanceStatusMap')
      this.$store.dispatch('getDictByName', 'tradeFreezerApplyStatusMap')
      this.$store.dispatch('getDictByName', 'tradeFreezerSolutionStatusMap')
      this.$store.dispatch('getDictByName', 'tradeFreezerExecutionStatusMap')
      this.$store.dispatch('getDictByName', 'tradFreezerAcceptanceStatusMap')
      this.$store.dispatch('getDictByName', 'tradeStackApplyStatusMap')
      this.$store.dispatch('getDictByName', 'tradeStackRequirementStatusMap')
      this.$store.dispatch('getDictByName', 'purchaseOrderStatusMap')
      this.$store.dispatch('getDictByName', 'purchaseOrderDetailStatusMap')
      this.$store.dispatch('getDictByName', 'purchaseOrderProofStatusMap')
      this.$store.dispatch('getDictByName', 'purchaseOrderTypeMap')
    },

    getShow (item) {
      // 级别低的仅按region筛选，不显示按bu筛选模块
      if (this.levelFlag === 'basic' && item.typeFlag === 'bu') {
        return false
      }
      return true
    },

    check (item) {
      if (!item.isPurchase) {
        // 非低级别，必选bu
        if (this.levelFlag !== 'basic' && !item.param.buCodes.length) {
          this.$message.error('请选择BU')
          return false
        }
        // 低级别，非trade明细导出，必选region
        if (
          this.levelFlag === 'basic' &&
          !item.param.regionCodes.length &&
          !item.isTrade
        ) {
          this.$message.error('请选择Region')
          return false
        }
      }
      return true
    },

    // 合并并处理传参
    filterParam (item) {
      let queryParams = {}

      // trade明细导出合并参数
      if (this.showTradeSub === 'showShopQuery') {
        queryParams = Object.assign({}, item.param, item.shopQueryParam)
      } else if (this.showTradeSub === 'showCoolerQuery') {
        queryParams = Object.assign({}, item.param, item.coolerQueryParam)
      } else if (this.showTradeSub === 'showStockQuery') {
        queryParams = Object.assign({}, item.param, item.stockQueryParam)
      } else {
        queryParams = Object.assign({}, item.param)
      }

      // 处理参数
      // reginCode和buCode 是否单选
      if (
        queryParams.regionCodes &&
        typeof queryParams.regionCodes === 'object'
      ) {
        queryParams.regionCodes = queryParams.regionCodes.join(',')
      }
      if (queryParams.buCodes && typeof queryParams.buCodes === 'object') {
        queryParams.buCodes = queryParams.buCodes.join(',')
      }

      // isTrade 处理参数
      if (item.isTrade) {
        if (queryParams.buCodes) {
          queryParams.buCode = queryParams.buCodes
          delete queryParams.buCodes
        }
        if (queryParams.regionCodes) {
          queryParams.regionCode = queryParams.regionCodes
          delete queryParams.regionCodes
        }
      }
      return queryParams
    },

    // 导出
    handleExport (item) {
      if (!this.check(item)) {
        return
      }
      // 获取当前导出数据的路径
      this.exportUrl = commonUtils.getApiUrl(item.api)
      this.exportParam = Object.assign({}, this.filterParam(item))
      this.$confirm('是否根据当前条件导出报表?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.form.submit()
        })
        .catch(() => {})
    },

    // 重置
    resetParam (item) {
      // trade明细导出
      if (item.isTrade) {
        if (item.param.buCodes.length) {
          item.regionList = this.$options.data().tradeParam.regionList
        }
        item.param = this.$options.data().tradeParam.param
        item.shopQueryParam = this.$options.data().tradeParam.shopQueryParam
        item.coolerQueryParam = this.$options.data().tradeParam.coolerQueryParam
        item.stockQueryParam = this.$options.data().tradeParam.stockQueryParam
        return
      }

      // 采购订单明细导出
      if (item.isPurchase) {
        if (item.param.buCodes.length) {
          item.regionList = this.$options.data().purchaseParam.regionList
        }
        item.param = this.$options.data().purchaseParam.param
        return
      }

      // reportList
      this.$options.data().reportList.forEach(initReportItem => {
        if (initReportItem.id === item.id) {
          // 若region根据bu出来的，就清空regionList
          if (item.param.buCodes.length) {
            item.regionList = initReportItem.regionList
          }
          item.param = initReportItem.param
        }
      })
    },

    // 获取渠道
    getChannel () {
      baseApi.getChannel().then(res => {
        if (res.data.resultCode === '0') {
          this.channelList = res.data.resultData.baseChannelList
        }
      })
    },

    // 获取bu-region
    getBuRegion () {
      this.loading = true
      this.$store
        .dispatch('queryBuRegion')
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            if (res.data.resultData.allList) {
              // 高级
              this.buList = res.data.resultData.allList
            } else if (res.data.resultData.buList) {
              // 中级
              this.buList = res.data.resultData.buList
            } else if (res.data.resultData.regionList) {
              // 低级
              this.levelFlag = 'basic'
              this.tradeParam.regionList = res.data.resultData.regionList
              this.purchaseParam.regionList = res.data.resultData.regionList
              this.reportList.forEach(item => {
                item.regionList = res.data.resultData.regionList
              })
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('数据有误，请及时联系管理员')
        })
    },

    // 根据bu动态获取region
    getRegion (item) {
      let arr = []

      item.param.regionCodes = ''
      if (item.param.buCodes.length === 0) {
        item.regionList = []
      }

      // 多选bu 依据bu拼接region下拉内容
      for (let i = 0; i < item.param.buCodes.length; i++) {
        this.buList.forEach(buItem => {
          if (buItem.orgCode === item.param.buCodes[i]) {
            arr.push(...buItem.subOrgList)
          }
        })
      }
      item.regionList = arr
    }

    // 时间开始选择器
    // startTimeStatus: function (value) {
    //   this.pickerOptionsEnd = {
    //     disabledDate: time => {
    //       let beginDateVal = value
    //       if (beginDateVal) {
    //         return (
    //           time.getTime() <= new Date(beginDateVal).getTime() - 86400000
    //         )
    //       }
    //     }
    //   }
    // },

    // 时间结束选择器
    // endTimeStatus: function (value) {
    //   this.pickerOptionsStart = {
    //     disabledDate: time => {
    //       let endDateVal = value
    //       if (endDateVal) {
    //         return time.getTime() >= new Date(endDateVal).getTime()
    //       }
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.report {
  .template {
    text-align: center;
  }
  .template-btn {
    padding: 7px 15px;
    margin: 5px 0;
  }
  .title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .el-select {
    width: 330px;
  }
  ::v-deep .el-select__tags {
    overflow: hidden;
  }
  li.el-select-dropdown__item {
    padding: 0 40px 0 20px;
  }
  .is-trade {
    .el-select {
      width: auto;
    }
  }
}
</style>
